var baseEndPoint = "aagasketapi.azurewebsites.net";
//var baseEndPoint = "localhost:7146";
let currentResultContainer = null;
let jsonDataMap = {};

function getStorageKey(resultContainer) {
  return `compare_part_${resultContainer}`;
}


window.addEventListener('load', function () {
  localStorage.clear(); // Clear local storage on page load
  console.log('Local storage cleared on page refresh');
  updateCurrentResultContainer();
});

/**
 * Updates the currentResultContainer based on the active tab
 */
function updateCurrentResultContainer() {
  const activeTab = document.querySelector('.nav-link.active');
  
  if (!activeTab) {
    console.error('No active tab found');
    return;
  }
  
  // Map of tab IDs to result container IDs
  const tabToResultMap = {
    'vehicleType-tab': 'resultsContainer',
    'regoVin-tab': 'resultsContainer2',
    'partNo-tab': 'resultsContainer3',
    'keySearch-tab': 'resultsContainer4'
  };
  
  const resultContainerId = tabToResultMap[activeTab.id];
  
  if (!resultContainerId) {
    console.error(`No result container mapped for tab: ${activeTab.id}`);
    return;
  }
  
  // Update the currentResultContainer variable
  currentResultContainer = resultContainerId;
  console.log(`Current result container updated to: ${currentResultContainer}`);
}

// Add event listeners to all tab buttons
document.addEventListener('DOMContentLoaded', function() {
  const tabButtons = document.querySelectorAll('.nav-link');
  
  tabButtons.forEach(button => {
    button.addEventListener('click', function() {
      // When a tab changes, update the currentResultContainer
      setTimeout(currentResultContainer, 100); // Small delay to ensure tab is activated
    });
  });
  
  // Bootstrap tabs trigger change event - listen for that too
  const tabList = document.querySelector('ul.nav-tabs');
  if (tabList) {
    tabList.addEventListener('shown.bs.tab', function(event) {
      // Update currentResultContainer when Bootstrap tab change completes
      updateCurrentResultContainer();
    });
  }
});

// Helper function to get the current container element
function getCurrentResultElement() {
  return document.getElementById(currentResultContainer);
}

// Example function to display results in the current container
function displayInCurrentContainer(content) {
  const container = getCurrentResultElement();
  if (container) {
    container.innerHTML = content;
  } else {
    console.error(`Container element not found: ${currentResultContainer}`);
  }
}


// Function to get the value of a cookie by name
function getCookieValue(cookieName) {

  const cookieString = document.cookie;
  const cookies = cookieString.split(';');
  for (const cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === cookieName) {
      return value != "undefined" ? value : null;
    }
  }
  return null;
}

async function fetchData(url) {
  try {
    const response = await fetch(url, {
      headers: {
        'xuserid': getCookieValue('xuserid')
      },
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const responseData = await response.json();

    // Set the 'xuserid' cookie with the value from the response
    document.cookie = `xuserid=${responseData.xuserid}; path=/`;

    // Access other data from the response
    const model = typeof responseData.model === "undefined" ? { groups: responseData.groups, vehicleDetails: responseData.vehicleDetails } : responseData.model;
    //console.log("result_data", responseData.model);
    return model;
  } catch (error) {
    console.error('Error fetching data:', error);
    return null;
  }
}

// Function to populate the page with data globally
async function populatePageWithData(data, resultContainer) {
  currentResultContainer = resultContainer;
  const resultsContainer = document.getElementById(currentResultContainer);
  resultsContainer.innerHTML = "";
  //console.log("result_data", data);

  jsonDataMap[currentResultContainer] = data; // Update the global variable with new data
  updateResultsContainer(currentResultContainer); // Update the page content
  // Inject the HTML content into the DOM
  //document.getElementById('dynamicContent').innerHTML = htmlContent;

  // Set up event listeners for dropdown items
  await setUpDropdownListeners();
  // Select all items by default
  const allItemsButton = document.getElementById('allItems');
  if (allItemsButton) {
    allItemsButton.click();
  }
}
async function setUpDropdownListeners() {
  const filterDropdownItems = document.querySelectorAll('.dropdown-item');

  await filterDropdownItems.forEach(item => {
    item.addEventListener('click', function (event) {
      event.preventDefault();
      const selectedFilter = event.target.id.replace('chk', '');

      // Hide all product catalogs
      const productCatalogs = document.querySelectorAll('.product-catalog');
      productCatalogs.forEach(catalog => {
        catalog.style.display = 'none';
      });

      // Show product catalogs of the selected filter
      if (selectedFilter === 'allItems') {
        productCatalogs.forEach(catalog => {
          catalog.style.display = 'block';
        });
      } else {
        const selectedCatalogs = document.querySelectorAll(`#groupContainer${selectedFilter}`);
        selectedCatalogs.forEach(catalog => {
          catalog.style.display = 'block';
        });
      }
    });
  });
  // Trigger click event on "All" dropdown item
  const allFilterItem = document.getElementById('allItems');
  allFilterItem?.click();
}
// Function to update the results container
function updateResultsContainer(resultContainer) {
currentResultContainer=resultContainer;
  const storageKey = getStorageKey(currentResultContainer);
  const storedPart = localStorage.getItem(storageKey);
  const storedPartData = storedPart ? JSON.parse(storedPart) : null;

//console.log("vehicle_Details",jsonData.vehicleDetails );
  // Extract data from the JSON object
  const Details = jsonDataMap[currentResultContainer].vehicleDetails;
  const groups = jsonDataMap[currentResultContainer].groups;
  //console.log("result_container",resultContainer);
  // Your existing HTML content
  //const storedPart = localStorage.getItem('compare_part');
  //const storedPartData = storedPart ? JSON.parse(storedPart) : null;
  let checkboxHtml = '';
  let compareButtonHtml = '';
 
  const htmlContent = `
  <div id="dynamicResult">
    <div class="d-flex mb-4 pb-4">
      <div class="col-md-8">
        <span class="fs-2 fw-bold lh-1">Results for:</span><br>
        <span class="fs-1 fw-black lh-1">${Details?.make} ${Details?.model} (${Details?.engineDetails})</span><br>
      </div>
      <div class="col-md-4 text-md-end mt-4">
          ${resultContainer === "resultsContainer4" ? 
        '<button id="backButton" class="btn btn-secondary">Back</button>' : 
        '<button href="search.html" class="btn btn-primary">Search again</button>'
      }
      </div>
    </div>
    ${(groups.length > 0 && groups.every(group => group.products.length === 0)) || groups.length == 0 ? `
      <p>Can’t find a listing for your vehicle? </p>
    ` : `
      <div class="row"> 
        <div class="col-9 mt-2">                       
        
        </div>
        <div class="d-flex col-3 justify-content-end mb-3">
          <div class="dropdown">
            <button class="btn btn-outline-primary dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
              Filter
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              <li class="list-group-item">
                <a class="dropdown-item" href="#" id="allItems">All</a>
              </li>
              ${groups.filter(group => group.products && group.products.length > 0).map(group => `
                <li class="list-group-item">
                  <a class="dropdown-item" href="#" id="chk${group.id}">${group.name}</a>
                </li>
              `).join('')}
            </ul>
          </div>
        </div> 
      </div>
      <div class="row">
        ${groups.map(group => {
    if (group.products && group.products.length > 0) {
      return group.products.map(product =>{ 
         let checkboxHtml = '';
                let compareButtonHtml = '';

                // Incorporate storedPart logic
                if (storedPartData) {
                  if (storedPartData.partNo === product.partNo) {
                    // Show the checked checkbox if the part is already selected
                    checkboxHtml = `
                      <input type="checkbox" class="form-check-input ${currentResultContainer}-detail-checkbox" data-part-no="${product.partNo}" checked style="cursor: pointer;">
                      <label class="form-check-label">Part Selected for Comparison</label>
                    `;
                  } else {
                    // Show the "Compare with X" button for other parts
                    compareButtonHtml = `
                      <button type="button" class="btn btn-primary ${currentResultContainer}-compare-button" data-${currentResultContainer}-compare-with="${storedPartData.partNo}" data-${currentResultContainer}-part-no="${product.partNo}">
                        Compare with ${storedPartData.partNo}
                      </button>
                    `;
                  }
                } else {
                  // Default checkbox if no part is selected
                  checkboxHtml = `
                    <input type="checkbox" class="form-check-input ${currentResultContainer}-detail-checkbox" data-${currentResultContainer}-part-no="${product.partNo}" style="cursor: pointer;">
                    <label class="form-check-label">Hold Part to Compare</label>
                  `;
                }

        
       return `
              
                <div class="product-catalog col-12 col-md-12 card mb-2" id="groupContainer${group.id}">
                  <div class="d-flex g-0">
                  <div class="col-2 col-md-2 border-end">

  <a href="#"><img src="https://api.autoinfo.com.au${product.imageUrl.includes("/thumb")? product.imageUrl.replace("/thumb", ""):(product.imageUrl || '')}" class="img-fluid rounded-start-2 view-image" alt="" data-image-url="https://api.autoinfo.com.au${product.imageUrl.includes("/thumb")? product.imageUrl.replace("/thumb", ""):(product.imageUrl || '')}"></a>
 
</div>

                    <div class="card-body col-9 col-md-9 card-h">
                      <div class="d-md-flex">
                        <div class="col-12 col-md-4 pe-2">
                          <div class="text-body">
                            <h4 class="card-title"><a href="#" class="pt-0">${group.name}</a></h4>
                            <h6 class="card-sub-title">${product.partNo}</h6>
                            <p class="text-danger">Quantity Required: ${product.pcq}</p>
                          </div>
                        </div>
                      <div class="col-12 col-md-5">
                          <div class="text-body">
                          ${product.footnote === product.longFootnote ?
          (product.footnote ?
            `<p class="card-text"><span class="text-primary"><strong>Note:</strong></span> ${product.footnote}</p>` :
            '') :
          (product.footnote ?
            `<p class="card-text"><span class="text-primary"><strong>Note:</strong></span> ${product.footnote}</p>` :
            '') +
          (product.longFootnote ?
            `<p class="card-text"><span class="text-primary"><strong>Note:</strong></span> ${product.longFootnote}</p>` :
            '')
        }     
                           </div>
                        </div>
                        <div class="col-3 col-md-3 pt-2 pt-md-0 d-flex flex-column align-items-start">
                        <div style="width: max-content;">
                        <button type="button" class="btn btn-primary me-2 my-1 view-details mx-auto d-block" aria-controls="modal-quick-view" data-product-url="${product.imageUrl}" data-product-id="${product.productId}" data-product='${JSON.stringify(product)}'>
                          View Details
                        </button>
                        </div>
                        <div style="width: max-content;">
                        ${checkboxHtml}
                        ${compareButtonHtml}   
                        </div>       
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                   `;
              }).join('');
            }
            return '';
          }).join('')}
        </div>
      `}
    </div>
  `;



  const resultsContainer = document.getElementById(currentResultContainer);
  resultsContainer.innerHTML = ""
  // Update the results container HTML content
  resultsContainer.innerHTML = htmlContent;
  // Initialize comparison functionality
  initializeCompareFunctionality();
  document.querySelectorAll('.view-image').forEach(image => {
    image.addEventListener('click', async function (e) {
      e.preventDefault();
      const imageUrl = this.getAttribute('data-image-url');

      // Open the image modal
      openImageModal(imageUrl);
    });
  });


  if (currentResultContainer === "resultsContainer4") {
    const backButton = document.getElementById("backButton");
    backButton.addEventListener("click", function() {
      document.getElementById('keySearchButton').click();
      // Add your event function here
     // console.log("Back button clicked");
      // You can add your custom logic here, like navigating to the previous page
      //window.history.back(); // Example: navigate to the previous page
    });
  }
  // JavaScript to handle modal content update
  document.querySelectorAll('.view-details').forEach(button => {
    button.addEventListener('click', async function (e) {
      let target = e.target;
      let productDataString = this.getAttribute('data-product');
      let product = JSON.parse(productDataString);
      e.preventDefault();

      let modal = document.getElementById(target.getAttribute('aria-controls'));
      modal.classList.add('is-loading');
      let content = await fetchProductDetailsAndOpenModal(product);
      modal.querySelector('.modal__inner').innerHTML = content;
      modal.classList.remove('is-loading');
      modal.classList.add('modal-dialog-centered');
      //modal.addEventListener('shown.bs.modal', initializeDetailCheckbox); // Add this line
      document.querySelector('body').classList.add('show_overlay');
      modal.setAttribute('aria-hidden', 'false');
    initializeDetailCheckbox();
    });
});
}

function initializeCompareFunctionality() {

  const componentCssForChk = `${currentResultContainer}-detail-checkbox`;
  const compareCheckboxes = document.querySelectorAll(`.${componentCssForChk}`);

  const componentCssForBtn = `${currentResultContainer}-compare-button`;
  const compareButtons = document.querySelectorAll(`.${componentCssForBtn}`);
 
  const storageKey = getStorageKey(currentResultContainer);
  // Array to track selected parts
  let selectedParts = [];

  // Handle checkbox interactions
  compareCheckboxes.forEach(checkbox => {
    checkbox.addEventListener('change', () => {
      const partNo = checkbox.getAttribute(`data-${currentResultContainer}-part-no`);

      if (checkbox.checked) {
        if (selectedParts.length < 2) {
          selectedParts.push(partNo);
          localStorage.setItem(storageKey, JSON.stringify({ partNo, timestamp: Date.now() }));

         // localStorage.setItem('compare_part', JSON.stringify({ partNo, timestamp: Date.now() }));
          console.log(`Part ${partNo} selected for comparison.`);
        } else {
          checkbox.checked = false; // Prevent more than 2 parts from being selected
          alert('You can only select two parts to compare.');
        }
      } else {
        selectedParts = selectedParts.filter(part => part !== partNo);
        localStorage.removeItem(storageKey);
        console.log(`Part ${partNo} removed from comparison.`);
      }

      // Re-render the results to update UI dynamically
      updateResultsContainer(currentResultContainer);
    });
  });

  // Handle "Compare with X" button interactions
  compareButtons.forEach(button => {
    button.addEventListener('click', async () => {
      const compareWithPart = button.getAttribute(`data-${currentResultContainer}-compare-with`);
      const currentPart = button.getAttribute(`data-${currentResultContainer}-part-no`);

      console.log(`Comparing ${currentPart} with ${compareWithPart}`);

      const details1 = await getPartDetailsFromGroups(compareWithPart);
      const details2 = await getPartDetailsFromGroups(currentPart);

      if (details1 && details2) {
        openComparisonModal(details1, details2);
      } else {
        console.error('Error: Unable to fetch details for selected parts.');
      }
    });
  });

  // Reset button functionality
  const resetButton = document.querySelector('#resetButton');
  if (resetButton) {
    resetButton.addEventListener('click', () => {
      selectedParts = [];
      localStorage.removeItem('compare_part');
      console.log('Comparison storage cleared.');
      updateResultsContainer(currentResultContainer); // Reset the UI
    });
  }
}

// function getCompareButtonOrCheckbox(partNo) {
//   const storedPart = localStorage.getItem('compare_part');

//   if (storedPart) {
//     const storedPartData = JSON.parse(storedPart);
//     return `
//       <button type="button" class="btn btn-primary compare-button" data-compare-with="${storedPartData.partNo}" data-part-no="${partNo}">
//         Compare with ${storedPartData.partNo}
//       </button>
//     `;
//   } else {
//     return `
//       <input type="checkbox" class="form-check-input detail-checkbox" data-part-no="${partNo}" style="cursor: pointer;">
//       <label class="form-check-label">Hold Part to Compare</label>
//     `;
//   }
// }
// Function to open the image modal
function openImageModal(imageUrl) {
  let modal = document.getElementById("modal-quick-view");
 
  // if (modal) {
  //   modal.addEventListener('shown.bs.modal', initializeDetailCheckbox);
  // }
  // Fetch image details and update modal content
  fetchImageDetailsAndOpenModal(imageUrl)
    .then(content => {
      modal.querySelector('.modal__inner').innerHTML = content;
      modal.classList.remove('is-loading');
      document.querySelector('body').classList.add('show_overlay');
      modal.setAttribute('aria-hidden', 'false');
    })
    .catch(error => console.error('Error fetching image details:', error));
}

// Function to handle modal content update for images
async function fetchImageDetailsAndOpenModal(imageUrl) {
  // Fetch image details if necessary (currently not implemented in the code)
  // Placeholder for fetching image details
  const imageDetails = {
    imageUrl: imageUrl // Assuming you might need some image details in the future
  };

  // Return the HTML content for the image modal
  return updateImageModalContent(imageDetails);
}

// Function to update image modal content
function updateImageModalContent(imageDetails) {
  // Construct HTML content for the image modal
  return `
    <div class="bg-white">
      <img src="${imageDetails.imageUrl}" class="img-fluid mx-auto d-block" alt="Image">
    </div>
  `;
}
async function  getPartDetailsFromGroups(partNo) {
  for (const group of jsonDataMap[currentResultContainer].groups) {
    for (const product of group.products) {
      if (product.partNo === partNo) {
        return await fetchProductDetails(product.productId)
        .then(async productDetails => {
          document.cookie = `xuserid=${productDetails?.xuserid}; path=/`;
          const proDetails = {
            ID: productDetails?.model?.dimensions?.find(d => d.description === "ID")?.dimensiondisplay,
            OD: productDetails?.model?.dimensions?.find(d => d.description === "OD")?.dimensiondisplay,
            Width: productDetails?.model?.dimensions?.find(d => d.description === "Width")?.dimensiondisplay,
            pictures: productDetails?.model?.pictures,
            height: productDetails?.model?.pictures[0]?.height,
            width: productDetails?.model?.pictures[0]?.width,
            notes: productDetails?.model?.notes,
            partFitments:productDetails?.partFitments,
            partNo: product.partNo,
            partDesc: product.partDesc,
            imageUrl: product.imageUrl,
            footnote: product.footnote,
            longFootnote: product.longFootnote,
            pcq: product.pcq,
          };
          return await  proDetails;
        })
        .catch(error => console.error('Error fetching product details:', error));
      
      }
    }
  }
  return null; // Return null if part is not found
}
// Function to fetch part details by ID
async function fetchPartDetailsById(partId) {
  try {
    const response = await fetch(`https://${baseEndPoint}/AutoInfoSearchAU/GetPartDetails?partId=${partId}`);
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = await response.json();
    return data; // Return the fetched part details
  } catch (error) {
    console.error('Error fetching part details:', error);
    return null; // Return null in case of error
  }
}
// Function to fetch product details and open modal
async function fetchProductDetailsAndOpenModal(product) {
  return await fetchProductDetails(product.productId)
    .then(async productDetails => {
      document.cookie = `xuserid=${productDetails?.xuserid}; path=/`;
      const proDetails = {
        "ID": productDetails?.model?.dimensions?.find(d => d.description === "ID")?.dimensiondisplay,
        "OD": productDetails?.model?.dimensions?.find(d => d.description === "OD")?.dimensiondisplay,
        "Width": productDetails?.model?.dimensions?.find(d => d.description === "Width")?.dimensiondisplay,
        "pictures": productDetails?.model?.pictures,
        "height": productDetails?.model?.pictures[0]?.height,
        "width": productDetails?.model?.pictures[0]?.width,
        "notes": productDetails?.model?.notes,
        "partFitments":productDetails?.partFitments
      };
      return await updateModalContent(product, proDetails);
    })
    .catch(error => console.error('Error fetching product details:', error));
}

// Function to fetch product details from backend API
function fetchProductDetails(productId) {
  // Replace this with actual fetch call to your backend API
  return new Promise((resolve, reject) => {
    // Example URL
    const apiUrl = `https://${baseEndPoint}/AutoInfoSearchAU/GetPartDetails?partId=${productId}`;
    fetch(apiUrl, {
      headers: {
        'xuserid': getCookieValue('xuserid')
      },
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        return response.json();
      })
      .then(data => {
        resolve(data);
      })
      .catch(error => {
        reject(error);
      });
  });
}

// Function to update modal content with product details
async function updateModalContent(productInfo, Details) {
  var notesHtml = ""
  //const modalContent = document.getElementById('modal-quick-view');
  if (Details.notes && Details.notes.length > 0) {
    //  console.log("product_info", Details.notes);
    notesHtml = Details.notes.map(note =>
      `<a class="btn btn-outline-primary my-1" href='https://${note.notepath}' target="_blank" download>${note.notedescription}</a> </br>`
    ).join('');
  }
  const storageKey = getStorageKey(currentResultContainer);
  const storedPart = localStorage.getItem(storageKey);
  let checkboxHtml = '';
  let compareButtonHtml = '';
  if (storedPart) {
  
  const storedPartData = storedPart ? JSON.parse(storedPart) : null;
    //const storedPartData = JSON.parse(storedPart);

    if (storedPartData.partNo === productInfo.partNo) {
      // If this part is already selected, show only the checked checkbox
      checkboxHtml = `
        <input type="checkbox" class="form-check-input ${currentResultContainer}-detail-checkbox" data-${currentResultContainer}-part-no="${productInfo.partNo}" checked style="cursor: pointer;">
        <label class="form-check-label">Part Selected for Comparison</label>
      `;
    } else {
      // Show the "Compare with X" button for other parts
      compareButtonHtml = `
        <button type="button" class="btn btn-primary ${currentResultContainer}-compare-button" data-${currentResultContainer}-compare-with="${storedPartData.partNo}" data-${currentResultContainer}-part-no="${productInfo.partNo}">
          Compare with ${storedPartData.partNo}
        </button>
      `;
    }
  } else {
    // If no part is selected, show the checkbox
    checkboxHtml = `
      <input type="checkbox" class="form-check-input ${currentResultContainer}-detail-checkbox" data-${currentResultContainer}-part-no="${productInfo.partNo}" style="cursor: pointer;">
      <label class="form-check-label">Hold Part to Compare</label>
    `;
  }

  let imagesHtml = '';
  if (Details.pictures && Details.pictures.length > 0) {
    imagesHtml = `<div class="col-md-6">` + Details.pictures.map(picture =>
      `<img src="${picture.picpath ? `https://api.autoinfo.com.au${picture.picpath}` : ''}" class="img-fluid" alt="${picture.picpath ? 'Image' : 'No Image Available'}">`
    ).join('') + `</div>`;
  }
  // Update modal content based on productDetails
  let fitmentImages='';
  if (Details.partFitments?.vehiclesImages && Details.partFitments?.vehiclesImages?.length > 0) {
  fitmentImages= Details.partFitments.vehiclesImages.map(image => {
   if (image && image.vehiclesImageUrl) {
       return `
           <div class="col-md-6">
               <img src="https://api.autoinfo.com.au${image.vehiclesImageUrl}" alt="Vehicle Image" class="img-fluid">
           </div>
       `;
   }
   return '';
}).join('');
         }
  const modalContent = `
     <div class="bg-white">
     
     <div class="modal-header position-relative">
        <h2 class="modal-title w-100 text-center">${productInfo.partNo}</h2>
        <div class="position-absolute" style="left: 15px; top: 50%; transform: translateY(-50%);">
            ${checkboxHtml}
          ${compareButtonHtml}
           <button type="button" class="btn btn-secondary ${currentResultContainer}-reset-button" style="margin-left: 10px;">Reset</button>
        </div>
      </div>
     <div class="modal-body">
     <div class="row">
   
     ${imagesHtml}
 
     <div class="col-md-6 modal-text">
     <p><span class="text-primary"><strong>Product Name:</strong></span> ${productInfo.partNo}</p>
     <p><span class="text-primary"><strong>Description:</strong></span><br/> ${productInfo.partDesc}</p>
     ${productInfo.footnote === productInfo.longFootnote ?
      (productInfo.footnote ?
        `<p><span class="text-primary"><strong>Note:</strong></span> ${productInfo.footnote}</p>` :
        '') :
      (productInfo.footnote ?
        `<p><span class="text-primary"><strong>Note:</strong></span> ${productInfo.footnote}</p>` :
        '') +
      (productInfo.longFootnote ?
        `<p><span class="text-primary"><strong>Note:</strong></span> ${productInfo.longFootnote}</p>` :
        '')
    }  
 
     ${Details.footnote ?
      `<p><span class="text-primary"><strong> Id:</strong></span> ${Details.ID}</p>` : ''}
     ${Details.OD ?
      `<p><span class="text-primary"><strong>OD:</strong></span> ${Details.OD}</p>` : ''}
     ${Details.Width ?
      `<p><span class="text-primary"><strong>Width:</strong></span> ${Details.Width}</p>` : ''}
       <div>
       ${notesHtml}
      </div>
     </div>
      ${fitmentImages}
     </div>
     </div>
     </div>
     `;
  return modalContent;
}


function handleCheckboxChange(e) {
  const isChecked = e.target.checked;
  const partNumber = e.target.getAttribute(`data-${currentResultContainer}-part-no`);
  const storageKey = getStorageKey(currentResultContainer);
  if (isChecked) {
    localStorage.setItem(storageKey, JSON.stringify({
      partNo: partNumber,
      timestamp: Date.now()
    }));
    console.log(`Part ${partNumber} selected for comparison`);
    updateResultsContainer(currentResultContainer); // Refresh the UI to show "Compare with" buttons
  } else {
    localStorage.removeItem(storageKey);
    console.log(`Part ${partNumber} removed from comparison`);
    updateResultsContainer(currentResultContainer); // Refresh the UI to show checkboxes again
  }
}

async function handleCompareButtonClick(e) {
  const compareWithPart = e.target.getAttribute(`data-${currentResultContainer}-compare-with`);

  const currentPart = e.target.getAttribute(`data-${currentResultContainer}-part-no`);

  console.log(`Comparing ${currentPart} with ${compareWithPart}`);

  // Close the current modal
  const modal = document.getElementById('modal-quick-view');
  if (modal) {
    modal.setAttribute('aria-hidden','true');
    modal.querySelector('.modal__inner').innerHTML = '';
    document.querySelector('body').classList.remove('show_overlay');
  }

  // Fetch details for both parts from jsonData.vehicleDetails
  const details1 =await getPartDetailsFromGroups(compareWithPart);
  const details2 =await getPartDetailsFromGroups(currentPart);

  if (details1 && details2) {
    //console.log('Details for both parts:', details1, details2);
    openComparisonModal(details1, details2);
  } else {
    console.error('Error: Unable to find details for one or both parts in jsonData.vehicleDetails.');
  }
}

function openComparisonModal(details1, details2) {
  const modalHtml = `
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Compare Parts</h5>
          </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-6 border-end">
             <h5>Part: ${details1.partNo || 'N/A'}</h5>
           <div class="zoom-container">
                <div class="zoom-wrapper">
                  <img src="https://api.autoinfo.com.au${ details1.pictures[0]?.picpath ||details1.imageUrl }" 
                       class="img-fluid zoom-image" 
                       alt="Part Image 2">
                </div>
              </div>
                 <div class="zoom-controls text-center mt-3">
                <button class="btn btn-sm btn-secondary zoom-out" data-target="1">-</button>
                <input type="range" class="zoom-slider" data-target="1" min="1" max="4" step="0.1" value="1">
                <button class="btn btn-sm btn-secondary zoom-in" data-target="1">+</button>
              </div>
             
              ${details1.ID ? `<p><strong>ID:</strong> ${details1.ID}</p>` : ''}
              ${details1.OD ? `<p><strong>OD:</strong> ${details1.OD}</p>` : ''} 
               ${details1.Width ? `<p><strong>Width:</strong> ${details1.Width}</p>` : ''} 
       
              <p><strong>Description:</strong> ${details1.partDesc || 'N/A'}</p>
              <p><strong>Footnote:</strong> ${details1.footnote || 'N/A'}</p>
              <p><strong>PCQ:</strong> ${details1.pcq || 'N/A'}</p>
              </div>             <div class="col-md-6">
              <h5>Part: ${details2.partNo}</h5>
             <div class="zoom-container">
                <div class="zoom-wrapper">
                  <img src="https://api.autoinfo.com.au${details2.pictures[0]?.picpath ||details2.imageUrl}" 
                       class="img-fluid zoom-image" 
                       alt="Part Image 2">
                </div>
              </div>
                  <div class="zoom-controls text-center mt-3">
                <button class="btn btn-sm btn-secondary zoom-out" data-target="2">-</button>
                <input type="range" class="zoom-slider" data-target="2" min="1" max="4" step="0.1" value="1">
                <button class="btn btn-sm btn-secondary zoom-in" data-target="2">+</button>
              </div>
           ${details2.ID ? `<p><strong>ID:</strong> ${details2.ID}</p>` : ''}
              ${details2.OD ? `<p><strong>OD:</strong> ${details2.OD}</p>` : ''} 
               ${details2.Width ? `<p><strong>Width:</strong> ${details2.Width}</p>` : ''} 
              <p><strong>Description:</strong> ${details2.partDesc || 'N/A'}</p>              
              <p><strong>Footnote:</strong> ${details2.footnote || 'N/A'}</p>
              <p><strong>PCQ:</strong> ${details2.pcq}</p>
              </div>
          </div>
        </div>
      </div>
    </div>
  `;
  let modal = document.getElementById("modal-quick-view");
  modal.querySelector('.modal__inner').innerHTML = modalHtml;
  modal.classList.remove('is-loading');
  modal.classList.add('modal-dialog-centered');
  document.querySelector('body').classList.add('show_overlay');
  modal.setAttribute('aria-hidden', 'false');
    // Initialize zoom functionality
    initializeZoom();
}

function initializeZoom() {
  const zoomImages = document.querySelectorAll('.zoom-image');

  zoomImages.forEach((image, index) => {
    // Initialize Panzoom for the current image
    const panzoomInstance = Panzoom(image, {
      maxScale: 4, // Maximum zoom scale
      contain: 'outside', // Keep image within container boundaries
    });

    // Find corresponding zoom controls
    const zoomOutButton = document.querySelector(`.zoom-out[data-target="${index + 1}"]`);
    const zoomInButton = document.querySelector(`.zoom-in[data-target="${index + 1}"]`);
    const zoomSlider = document.querySelector(`.zoom-slider[data-target="${index + 1}"]`);

    // Ensure buttons and slider are linked to the correct image
    if (zoomOutButton && zoomInButton && zoomSlider) {
      // Event listener for zoom-out button
      zoomOutButton.addEventListener('click', () => {
        panzoomInstance.zoomOut();
        zoomSlider.value = panzoomInstance.getScale().toFixed(2); // Sync slider value
      });

      // Event listener for zoom-in button
      zoomInButton.addEventListener('click', () => {
        panzoomInstance.zoomIn();
        zoomSlider.value = panzoomInstance.getScale().toFixed(2); // Sync slider value
      });

      // Event listener for slider
      zoomSlider.addEventListener('input', (e) => {
        const scale = parseFloat(e.target.value);
        panzoomInstance.zoom(scale); // Adjust zoom based on slider
      });

      // Enable zoom with wheel
      image.parentElement.addEventListener('wheel', panzoomInstance.zoomWithWheel);
    } else {
      console.error('Zoom controls not found for image index:', index);
    }
  });
}

function handleResetButtonClick() {
  if (!currentResultContainer) return; // Ensure resultContainer is set
  const storageKey = getStorageKey(currentResultContainer);
  localStorage.removeItem(storageKey);
  //localStorage.removeItem('compare_part');
  console.log('Comparison storage cleared');
  const modal = document.getElementById('modal-quick-view');

  if (modal) {
    // Check if the modal is currently shown
       modal.setAttribute('aria-hidden','true');
      modal.querySelector('.modal__inner').innerHTML = '';
      document.querySelector('body').classList.remove('show_overlay');
    
  }
  initializeDetailCheckbox();
}
function initializeDetailCheckbox() {
  const modal = document.getElementById('modal-quick-view');
  const componentCssForChk = `${currentResultContainer}-detail-checkbox`;
  const componentCssForBtn = `${currentResultContainer}-compare-button`;
  const componentCssForResetBtn = `${currentResultContainer}-reset-button`;

  modal.querySelectorAll(`.${componentCssForChk}`).forEach(checkbox => {
    checkbox.removeEventListener('change', handleCheckboxChange);
    checkbox.addEventListener('change', handleCheckboxChange);
  });

  modal.querySelectorAll(`.${componentCssForBtn}`).forEach(button => {
    button.removeEventListener('click', handleCompareButtonClick);
    button.addEventListener('click', handleCompareButtonClick);
  });

  modal.querySelectorAll(`.${componentCssForResetBtn}`).forEach(button => {
    button.removeEventListener('click', handleResetButtonClick);
    button.addEventListener('click', handleResetButtonClick);
  });
}
function displayComparisonDetails(part1, part2) {
  console.log(`Displaying details for ${part1} and ${part2}`);
  // Logic to fetch and display details for part1 and part2 side by side
}
document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('modal-quick-view');
  if (modal) {
    modal.addEventListener('shown.bs.modal', initializeDetailCheckbox);
  }
});


// Function to handle initial checkbox state and show/hide related group products
function initializeCheckboxes() {
  const checkboxes = document.querySelectorAll('input[type="checkbox"]:not(#chkAll)');

  checkboxes.forEach(checkbox => {
    const groupId = checkbox.id.replace('chk', '');
    checkbox.checked = groupId === 'All'; // Check the "All" checkbox initially, uncheck others
    toggleVisibility(groupId);
  });
}
// Function to toggle visibility based on checkbox state
function toggleVisibility(groupId, isChecked) {

  const groupContainer = groupId === "All" ? document.getElementById("allProductsContainer") : document.getElementById('groupContainer' + groupId);

  if (groupContainer) {
    isChecked ? groupContainer.classList.remove("d-none") : groupContainer.classList.add("d-none");
  }
}
document.addEventListener('DOMContentLoaded', function () {
  var modelDropdown = document.getElementById('model');
  // var submodelDropdown = document.getElementById('submodel');
  var makeDropdown = document.getElementById('make');
  var yearDropdown = document.getElementById('year');
  var seriesDropdown = document.getElementById('series');
  var engineDropdown = document.getElementById('engine');
  var vehicleDropdown = document.getElementById('vehicle');
  const resultsContainer = document.getElementById(currentResultContainer || 'resultsContainer');
  resultsContainer.innerHTML = '';
  var vehicleDetails = {};
  var jsonData = {}
  // var baseEndPoint = "aagasketapi.azurewebsites.net";
  // var baseEndPoint = "localhost:7146";

  document.getElementById('vresetId').addEventListener('click', function () {
    // Reset dropdowns to their initial state
    document.getElementById('make').selectedIndex = 0;
    //document.getElementById('model').selectedIndex = 0;
    // document.getElementById('yearDropdown').selectedIndex = 0;
    // document.getElementById('seriesDropdown').selectedIndex = 0;
    // Add more dropdowns as needed
    // populateDropdown(submodelDropdown, null);
    populateDropdown(modelDropdown, null);
    populateDropdown(yearDropdown, null);
    populateDropdown(seriesDropdown, null);
    populateDropdown(engineDropdown, null);
    populateDropdown(vehicleDropdown, null);
    // Optionally, clear the results container
    const resultsContainer = document.getElementById(currentResultContainer);
    resultsContainer.innerHTML = '';
  })

  // const quickViewModal = document.getElementById('modal-quick-view');
  // if (quickViewModal) {
  //   quickViewModal.addEventListener('shown.bs.modal', initializeDetailCheckbox);
  // }


  // Function to populate a dropdown with options
  function populateDropdown(dropdown, options) {
    if (dropdown) {
      dropdown.value = ""

      if ((dropdown.id === "year" || dropdown.id === "series" || dropdown.id === "engine" || dropdown.id === "submodel" || dropdown.id === "vehicle") && options)
        dropdown.innerHTML = '<option value="">- Select -</option>'; // Clear previous options

      if (options) {
        options.forEach(option => {
          var optionElement = document.createElement('option');
          optionElement.value = option;
          optionElement.text = option;
          dropdown.add(optionElement);
        });
        dropdown.disabled = false; // Enable the dropdown
        if (options.length === 1) {
          dropdown.value = options[0];
          dropdown.dispatchEvent(new Event('change'));
        }
      } else {
        dropdown.innerHTML = '';
        dropdown.disabled = true; // Disable the dropdown
      }
    }
  }

  // Populate the "Make" dropdown from the API
  // var makeDropdown = document.getElementById('make');
  fetchData(`https://${baseEndPoint}/AutoInfoSearchAU/GetPartsGuide?ReturnField=Make&PA=true`)
    .then(data => {
      if (data) {
        // Clear existing options
        // makeDropdown.innerHTML = '<option value="- Popular Makes -">- Popular Makes -</option>';

        // Populate options dynamically
        data.options.forEach(make => {
          const option = document.createElement('option');
          option.value = make;
          option.textContent = make;
          makeDropdown.appendChild(option);
        });
      }
    })
    .catch(error => console.error('Error fetching data:', error)).finally(() => {
      // populateDropdown(submodelDropdown, null);
      populateDropdown(modelDropdown, null);
      populateDropdown(yearDropdown, null);
      populateDropdown(seriesDropdown, null);
      populateDropdown(engineDropdown, null);
      populateDropdown(vehicleDropdown, null);
    });
  // Add event listener to the "Make" dropdown
  // var makeDropdown = document.getElementById('make');
  makeDropdown.addEventListener('change', function () {
    var selectedMake = makeDropdown.value;

    // Reset other dropdowns

    //populateDropdown(submodelDropdown, null);
    populateDropdown(modelDropdown, null);
    populateDropdown(yearDropdown, null);
    populateDropdown(seriesDropdown, null);
    populateDropdown(engineDropdown, null);
    populateDropdown(vehicleDropdown, null);

    // Show spinner while fetching data
    var spinner = document.getElementById('loadingSpinner');
    spinner.style.display = 'inline-block';

    if (selectedMake) {
      // Fetch and populate the "Model" dropdown
      fetchData(`https://${baseEndPoint}/AutoInfoSearchAU/GetPartsGuide?ReturnField=Model&make=${selectedMake}&PA=true`)
        .then(models => populateDropdown(modelDropdown, models.options))
        .finally(() => spinner.style.display = 'none');
    }
  });

  // Add event listener to the "Model" dropdown
  // var modelDropdown = document.getElementById('model');
  modelDropdown.addEventListener('change', function () {
    // var makeDropdown = document.getElementById('make');
    selectedMake = makeDropdown.value;
    var selectedModel = modelDropdown.value;
    //populateDropdown(submodelDropdown, null);
    populateDropdown(yearDropdown, null);
    populateDropdown(seriesDropdown, null);
    populateDropdown(engineDropdown, null);
    populateDropdown(vehicleDropdown, null);

    if (selectedModel) {
      var spinner = document.getElementById('loadingSpinner');
      spinner.style.display = 'inline-block';
      // Fetch and populate the "Year" dropdown
      fetchData(`https://${baseEndPoint}/AutoInfoSearchAU/GetPartsGuide?ReturnField=year&make=${selectedMake.trim()}&model=${selectedModel.trim()} &PA=true`)
        .then(years => populateDropdown(yearDropdown, years.options))
        .finally(() => spinner.style.display = 'none');
    }
  });


  yearDropdown.addEventListener('change', function () {
    var selectedYear = yearDropdown.value;

    var selectedMake = makeDropdown.value;
    var selectedModel = modelDropdown.value;
    //var selectedSubModel = submodelDropdown.value;
    populateDropdown(seriesDropdown, null);
    populateDropdown(engineDropdown, null);
    populateDropdown(vehicleDropdown, null);

    if (selectedYear) {
      var spinner = document.getElementById('loadingSpinner');
      spinner.style.display = 'inline-block';
      // Fetch and populate the "Series" dropdown
      fetchData(`https://${baseEndPoint}/AutoInfoSearchAU/GetPartsGuide?ReturnField=Series&make=${selectedMake.trim()}&model=${selectedModel.trim()} &year=${selectedYear.trim()}&PA=true`)
        .then(series => populateDropdown(seriesDropdown, series.options))
        .finally(() => spinner.style.display = 'none');
    }
  });

  // Add event listener to the "Series" dropdown

  seriesDropdown.addEventListener('change', function () {

    var selectedMake = makeDropdown.value;
    var selectedModel = modelDropdown.value;
    var selectedYear = yearDropdown.value;
    //var selectedSubModel = submodelDropdown.value;
    var selectedSeries = seriesDropdown.value;

    populateDropdown(engineDropdown, null);
    populateDropdown(vehicleDropdown, null);

    if (selectedSeries) {
      var spinner = document.getElementById('loadingSpinner');
      spinner.style.display = 'inline-block';
      // Fetch and populate the "Engine" dropdown
      fetchData(`https://${baseEndPoint}/AutoInfoSearchAU/GetPartsGuide?ReturnField=Engine&make=${selectedMake.trim()}&model=${selectedModel.trim()} &year=${selectedYear.trim()}&series=${selectedSeries.trim()}&PA=true`)
        .then(engines => populateDropdown(engineDropdown, engines.options))
        .finally(() => spinner.style.display = 'none');
    }
  });

  // Add event listener to the "Engine" dropdown
  // var engineDropdown = document.getElementById('engine');
  engineDropdown.addEventListener('change', function () {
    var selectedMake = makeDropdown.value;
    var selectedModel = modelDropdown.value;
    var selectedYear = yearDropdown.value;
    var selectedSeries = seriesDropdown.value;
    //var selectedSubModel = submodelDropdown.value;
    var selectedEngine = engineDropdown.value;

    // Reset other dropdowns
    // var vehicleDropdown = document.getElementById('vehicle');
    populateDropdown(vehicleDropdown, null);

    if (selectedEngine) {
      var spinner = document.getElementById('loadingSpinner');
      spinner.style.display = 'inline-block';
      // Fetch and populate the "Vehicle" dropdown
      fetchData(`https://${baseEndPoint}/AutoInfoSearchAU/GetPartsGuide?ReturnField=Details&make=${selectedMake.trim()}&model=${selectedModel.trim()} &year=${selectedYear.trim()}&series=${selectedSeries.trim()}&engine=${selectedEngine.trim()}&PA=true`)
        .then(vehicles => { populateDropdown(vehicleDropdown, vehicles.options); vehicleDetails = vehicles.details })
        .finally(() => spinner.style.display = 'none');
    }
  });





  document.getElementById(currentResultContainer|| 'resultsContainer').addEventListener('change', function (event) {
    const target = event.target;
    if (event.target.id === 'chkAll') {
      // If "All" checkbox is checked, uncheck other checkboxes and show all products
      toggleVisibility('All', target.checked);
      const checkboxes = document.querySelectorAll('input[type="checkbox"]:not(#chkAll)');

      checkboxes.forEach(checkbox => {
        const groupId = checkbox.id.replace('chk', '');
        checkbox.checked = false; // Check the "All" checkbox initially, uncheck others
        toggleVisibility(groupId);
      });
    } else if (target.matches('input[type="checkbox"]')) {
      // If any other checkbox is checked, uncheck "All" checkbox and show/hide products based on the checkbox state
     
      const chkAllElement = document.getElementById('chkAll');

      // Check if the element exists
      if (chkAllElement) {
      // If it exists, set the `checked` property to `false`
      chkAllElement.checked = false;
      }
      toggleVisibility('All', false);
      const groupId = target.id.replace('chk', '');
      toggleVisibility(groupId, target.checked);
    }
  });



  // Add an event listener to the "Search" button
  document.getElementById('vehicleSearch').addEventListener('click', function () {
    var vehicleDropdown = document.getElementById('vehicle');
    var spinner = document.getElementById('loadingSpinner');
    var selectedVehicle = vehicleDropdown.value;
    // var xuserid = getCookieValue('xuserid');

    // const headers = {
    //   'xuserid': xuserid,
    //   // Add other headers if needed
    // };

    //console.log("vehicleDetails", vehicleDetails)
    selectedVehicleDetails = vehicleDetails.find(vehicle => vehicle.option === selectedVehicle);
    // Check if a vehicle is selected
    if (selectedVehicleDetails) {
      //console.log("vehicleId", selectedVehicleDetails)
      //var vehicleId = vehicleDetails[0].vehicleId;
      //if (vehicleId) {
      // Fetch data based on the vehicleId
      const apiUrl = `https://${baseEndPoint}/AutoInfoSearchAU/GetSearchResultsByKey?vehicleId=${selectedVehicleDetails.vehicleIdEncrypted}`;
      spinner.style.display = 'inline-block'; // Show the spinner before making the request

      fetchData(apiUrl)
        .then(data => {
          // console.log("result_data", data);
          if (data) {
            // Populate the page with fetched data
            populatePageWithData(data, currentResultContainer);
            // Show the result div
            document.getElementById('resultDiv').style.display = 'block';
            // Hide the no parts found message
            //document.getElementById('noPartsFound').style.display = 'none';
          } else {
            // Show the no parts found message
            // document.getElementById('noPartsFound').style.display = 'block';
            // Hide the result div
            document.getElementById('resultDiv').style.display = 'none';
          }

        }).finally(() => {
          // Hide the spinner after data processing is complete (whether successful or not)
          spinner.style.display = 'none';
        });
      //}
      // Construct the URL with the selected vehicle ID
      // var resultPageUrl = `search-result.html?vehicleId=` + vehicleDetails[0].vehicleId;

      // Redirect to the result page
      // window.location.href = resultPageUrl;
    } else {
      // Handle the case where no vehicle is selected, e.g., show an alert
      alert('Please select a vehicle before searching.');
    }
    //initializeCheckboxes();
  });
  //initializeCheckboxes();
  const modal = document.getElementById('modal-quick-view');
  if (modal) {
    modal.addEventListener('shown.bs.modal', function() {
      setTimeout(initializeDetailCheckbox, 100);
    });
  }


});
